import Offcanvas from "@components/new_offcanvas/offcanvas_menu"

export default function OffcanvasComponent(opts={}){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this

    let offcanvas

    this.generate = () =>{
        offcanvas = new Offcanvas({id: 'offcanvas-station', position: 'right', width: 'offcanvas-wsm'})
        offcanvas.generate()
        offcanvas.show()
    }

    this.update = () =>{

    }
}

OffcanvasComponent.prototype = Object.create(BaseConstructor.prototype)